import { GTMPushEvent } from "./../index";

export const Ga4WithEventParameters = ({ eventName = "", eventParameters = {} }) => {
  GTMPushEvent({
    event: "ga4_event",
    event_name: eventName,
    event_parameters: eventParameters,
  });
};
